import { useSubscription } from '../entities/subscription';

export const useIsSubscriptionExpired = () => {
  const { data: subscription } = useSubscription();
  return subscription?.status === 'canceled';
};
